import type React from 'react';
import { useFeedbackCollectorUrl } from '@/hooks/useFeedbackCollectorUrl';
import type { FeatureFeedbackCollectorProps } from '@/types/feedbackCollector';

/**
 * A reusable feedback collector component that wraps the oc-component.
 * 
 * This component automatically sources:
 * - userId from TimesheetContext (currentEmployee)
 * - customerName from CompanyContext (currentCompany)
 * - product, baseUrl, and accountToken from configuration
 * 
 * Only the `feature` prop needs to be specified per usage.
 * 
 * @example
 * ```tsx
 * <FeatureFeedbackCollector feature="Homepage" />
 * <FeatureFeedbackCollector feature="Timesheet Quick Entry" />
 * ```
 */
export const FeatureFeedbackCollector: React.FC<FeatureFeedbackCollectorProps> = ({
  feature,
  className,
}) => {
  const url = useFeedbackCollectorUrl(feature);

  if (!url) {
    return null;
  }

  return <oc-component href={url} className={className} />;
};

export default FeatureFeedbackCollector;
